module.exports = __webpack_public_path__ + "img/register-warning.fc157c7d.svg";